<template>
  <div class="container-tourist-attractions">
    <span class="container-tourist-attractions-title">Pontos turísticos mais citados</span>
    <CustomSkeleton v-if="isSearching" type="horizontalGraph" />

    <span v-if="touristAttraction.length === 0 && !isSearching" class="no-data-text">
      Não há pontos turísticos mais citados nessa data.
    </span>
    <canvas
      v-if="!isSearching"
      id="tourist-attractions-chart"
      class="tourist-attractions-chart"
    ></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js'
import CustomSkeleton from '@/Shared/CustomSkeleton'
Chart.register(...registerables)
export default {
  components: {
    CustomSkeleton,
  },
  props: {
    isSearching: Boolean,
    touristAttraction: Array,
  },
  data() {
    return {
      isLoadingReviews: false,
      chart: null,
    }
  },
  watch: {
    isSearching: {
      handler(n, o) {
        if (o === true) {
          setTimeout(() => {
            this.createChart()
          }, 1000)
        }
      },
      immediate: true,
    },
  },
  methods: {
    createChart() {
      if (this.chart) {
        this.chart.destroy()
      }
      const ctx = document.getElementById('tourist-attractions-chart').getContext('2d')
      const canvas = document.getElementById('tourist-attractions-chart')
      canvas.width = canvas.parentElement.clientWidth
      canvas.height = 400

      const labels = this.touristAttraction.map((attraction) => attraction.name)
      const data = this.touristAttraction.map((attraction) => attraction.review_count)
      const backgroundColors = '#9747FF'
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: 'Quantidade de menções',
              data,
              backgroundColor: backgroundColors,
              borderWidth: 1,
              barThickness: 20,
              maxBarThickness: 30,
              minBarLength: 1,
            },
          ],
        },
        options: {
          indexAxis: 'x',
          scales: {
            x: {
              display: true,
              beginAtZero: true,
              ticks: {
                display: true,
                minRotation: 0,
                maxRotation: 90,
                autoSkip: false,
                callback: (value) => value,
              },
              title: {
                display: false,
              },
            },
            y: {
              display: true,
              beginAtZero: true,
              ticks: {
                callback: (value) => (value >= 1000 ? `${value / 1000}k` : value),
              },
              title: {
                display: false,
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              callbacks: {
                title: (context) => labels[context[0].dataIndex],
                label: (context) => `${context.dataset.label}: ${context.raw}`,
              },
            },
          },
        },
      })
    },
  },
}
</script>

<style lang="scss" src="./styles.scss"></style>
